!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define("reactn", ["react"], e) : "object" == typeof exports ? exports.reactn = e(require("react")) : t.reactn = e(t.React);
}("undefined" != typeof self ? self : this, function (t) {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 12);
  }([function (t, e, n) {
    "use strict";

    n.d(e, "e", function () {
      return i;
    }), n.d(e, "a", function () {
      return a;
    }), n.d(e, "c", function () {
      return c;
    }), n.d(e, "b", function () {
      return l;
    }), n.d(e, "d", function () {
      return f;
    });

    var r = n(3),
        o = n(2),
        u = function u() {
      return r.a._currentValue2 || o.default;
    };

    function i(t) {
      return function (e) {
        for (var n = u(), r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) {
          o[i - 1] = arguments[i];
        }

        var a = t.getDerivedGlobalFromProps.apply(t, [e, n.stateWithReducers].concat(o));
        return n.setAny(a), Object.prototype.hasOwnProperty.call(t, "getDerivedStateFromProps") ? t.getDerivedStateFromProps.apply(t, [e].concat(o)) : null;
      };
    }

    function a(t) {
      u().removePropertyListener(t._globalCallback);
    }

    function c(t) {
      t.updater.enqueueForceUpdate(t, null, "forceUpdate");
    }

    function l(t) {
      return (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : u()).spyStateWithReducers(t._globalCallback);
    }

    function f(t, e, n, r) {
      var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : u();
      r ? o.setAnyCallback(e, n) : setTimeout(function () {
        f(t, e, n, !0, o);
      }, 0);
    }
  }, function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(6);
    e.default = new r.a();
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
        o = n(2);
    e.a = Object(r.createContext)(o.default);
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
      return t.setAnyCallback(e, n);
    }

    n.r(e), n.d(e, "default", function () {
      return r;
    });
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return o;
    });
    var r = n(2);

    function o(t) {
      return function () {
        for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) {
          n[o] = arguments[o];
        }

        return r.default.setAny(t.apply(void 0, [r.default.stateWithReducers].concat(n)));
      };
    }
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function o(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        var n = [],
            r = !0,
            o = !1,
            u = void 0;

        try {
          for (var i, a = t[Symbol.iterator](); !(r = (i = a.next()).done) && (n.push(i.value), !e || n.length !== e); r = !0) {
            ;
          }
        } catch (t) {
          o = !0, u = t;
        } finally {
          try {
            r || null == a.return || a.return();
          } finally {
            if (o) throw u;
          }
        }

        return n;
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    function u(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    n.d(e, "a", function () {
      return i;
    });

    var i = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.reset();
      }

      return function (t, e, n) {
        e && u(t.prototype, e), n && u(t, n);
      }(t, [{
        key: "addCallback",
        value: function value(t) {
          var e = this;
          return this._callbacks.add(t), function () {
            e.removeCallback(t);
          };
        }
      }, {
        key: "addPropertyListener",
        value: function value(t, e) {
          this._propertyListeners.has(t) ? this._propertyListeners.get(t).add(e) : this._propertyListeners.set(t, new Set([e]));
        }
      }, {
        key: "addReducer",
        value: function value(t, e) {
          var n = this;

          if (this.hasReducer(t)) {
            if (this.getReducer(t) === e) return;
            throw new Error("A reducer named ".concat(t, " already exists."));
          }

          return this._reducers.set(t, e), function () {
            n.removeReducer(t);
          };
        }
      }, {
        key: "beginTransaction",
        value: function value() {
          return this._transactionId = (this._transactionId + 1) % 9007199254740990, this._transactions.set(this._transactionId, {
            delete: new Set(),
            propertyListeners: new Set(),
            state: new Map()
          }), this._transactionId;
        }
      }, {
        key: "commit",
        value: function value(t) {
          var e = this._transactions.get(t),
              n = !0,
              r = !1,
              u = void 0;

          try {
            for (var i, a = e.delete[Symbol.iterator](); !(n = (i = a.next()).done); n = !0) {
              var c = i.value;
              delete this._state[c];
            }
          } catch (t) {
            r = !0, u = t;
          } finally {
            try {
              n || null == a.return || a.return();
            } finally {
              if (r) throw u;
            }
          }

          var l = !0,
              f = !1,
              s = void 0;

          try {
            for (var y, p = e.state.entries()[Symbol.iterator](); !(l = (y = p.next()).done); l = !0) {
              var b = o(y.value, 2),
                  d = b[0],
                  v = b[1];
              this._state[d] = v;
            }
          } catch (t) {
            f = !0, s = t;
          } finally {
            try {
              l || null == p.return || p.return();
            } finally {
              if (f) throw s;
            }
          }

          var h = !0,
              m = !1,
              g = void 0;

          try {
            for (var O, j = e.propertyListeners[Symbol.iterator](); !(h = (O = j.next()).done); h = !0) {
              (0, O.value)();
            }
          } catch (t) {
            m = !0, g = t;
          } finally {
            try {
              h || null == j.return || j.return();
            } finally {
              if (m) throw g;
            }
          }

          this._transactions.delete(t);

          var w = !0,
              _ = !1,
              k = void 0;

          try {
            for (var P, S = this._callbacks[Symbol.iterator](); !(w = (P = S.next()).done); w = !0) {
              var R = P.value;
              this.setAny(R(this.stateWithReducers));
            }
          } catch (t) {
            _ = !0, k = t;
          } finally {
            try {
              w || null == S.return || S.return();
            } finally {
              if (_) throw k;
            }
          }
        }
      }, {
        key: "getReducer",
        value: function value(t) {
          return this._reducers.get(t);
        }
      }, {
        key: "getReducers",
        value: function value() {
          var t = Object.create(null),
              e = !0,
              n = !1,
              r = void 0;

          try {
            for (var u, i = this._reducers.entries()[Symbol.iterator](); !(e = (u = i.next()).done); e = !0) {
              var a = o(u.value, 2),
                  c = a[0],
                  l = a[1];
              t[c] = l;
            }
          } catch (t) {
            n = !0, r = t;
          } finally {
            try {
              e || null == i.return || i.return();
            } finally {
              if (n) throw r;
            }
          }

          return t;
        }
      }, {
        key: "hasPropertyListener",
        value: function value(t) {
          return this._propertyListeners.has(t);
        }
      }, {
        key: "hasReducer",
        value: function value(t) {
          return this._reducers.has(t);
        }
      }, {
        key: "removeCallback",
        value: function value(t) {
          this._callbacks.delete(t);
        }
      }, {
        key: "removePropertyListener",
        value: function value(t) {
          var e = !0,
              n = !1,
              r = void 0;

          try {
            for (var o, u = this._propertyListeners.values()[Symbol.iterator](); !(e = (o = u.next()).done); e = !0) {
              o.value.delete(t);
            }
          } catch (t) {
            n = !0, r = t;
          } finally {
            try {
              e || null == u.return || u.return();
            } finally {
              if (n) throw r;
            }
          }

          var i = !0,
              a = !1,
              c = void 0;

          try {
            for (var l, f = this._transactions.values()[Symbol.iterator](); !(i = (l = f.next()).done); i = !0) {
              l.value.propertyListeners.delete(t);
            }
          } catch (t) {
            a = !0, c = t;
          } finally {
            try {
              i || null == f.return || f.return();
            } finally {
              if (a) throw c;
            }
          }
        }
      }, {
        key: "removeReducer",
        value: function value(t) {
          this._reducers.remove(t);
        }
      }, {
        key: "reset",
        value: function value() {
          this._callbacks = new Set(), this._propertyListeners = new Map(), this._reducers = new Map(), this._state = Object.create(null), this._transactionId = 0, this._transactions = new Map();
        }
      }, {
        key: "set",
        value: function value(t, e, n) {
          if (this.hasReducer(t)) return n;

          var r = this._transactions.get(n);

          void 0 === e ? r.delete.add(t) : r.state.set(t, e);

          var o = this._propertyListeners.get(t);

          if (o) {
            var u = !0,
                i = !1,
                a = void 0;

            try {
              for (var c, l = o[Symbol.iterator](); !(u = (c = l.next()).done); u = !0) {
                var f = c.value;
                r.propertyListeners.add(f);
              }
            } catch (t) {
              i = !0, a = t;
            } finally {
              try {
                u || null == l.return || l.return();
              } finally {
                if (i) throw a;
              }
            }
          }

          return n;
        }
      }, {
        key: "setAny",
        value: function value(t) {
          if (null !== t && void 0 !== t) {
            if (t instanceof Promise) return this.setPromise(t);
            if ("function" == typeof t) return this.setFunction(t);
            if ("object" === r(t)) return this.setObject(t);
            throw new Error("Global state must be a function, null, object, or Promise.");
          }
        }
      }, {
        key: "setAnyCallback",
        value: function value(t) {
          var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
              r = this.setAny(t);
          "function" == typeof n && (r instanceof Promise ? r.then(function () {
            n(e.stateWithReducers);
          }) : n(this.stateWithReducers));
        }
      }, {
        key: "setFunction",
        value: function value(t) {
          return this.setAny(t(this.stateWithReducers));
        }
      }, {
        key: "setObject",
        value: function value(t) {
          for (var e = this.beginTransaction(), n = Object.entries(t), r = 0; r < n.length; r++) {
            var u = o(n[r], 2),
                i = u[0],
                a = u[1];
            this.set(i, a, e);
          }

          this.commit(e);
        }
      }, {
        key: "setPromise",
        value: function value(t) {
          var e = this;
          return t.then(function (t) {
            return e.setAny(t);
          });
        }
      }, {
        key: "spyState",
        value: function value(t) {
          var e = this;
          return function (t, e) {
            return Object.keys(t).reduce(function (n, r) {
              return Object.defineProperty(n, r, {
                configurable: !1,
                enumerable: !0,
                get: function get() {
                  return e(r), t[r];
                }
              }), n;
            }, Object.create(null));
          }(this._state, function (n) {
            e.addPropertyListener(n, t);
          });
        }
      }, {
        key: "spyStateWithReducers",
        value: function value(t) {
          return Object.assign(this.spyState(t), this.getReducers());
        }
      }, {
        key: "state",
        get: function get() {
          return Object.assign(Object.create(null), this._state);
        }
      }, {
        key: "stateWithReducers",
        get: function get() {
          return Object.assign(this.state, this.getReducers());
        }
      }]), t;
    }();
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "ReactNComponent", function () {
      return p;
    }), n.d(e, "ReactNPureComponent", function () {
      return b;
    });
    var r = n(1),
        o = n(0);

    function u(t) {
      return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function a(t) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function c(t, e) {
      return (c = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function l(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    var f = function f(t) {
      if (Object.prototype.hasOwnProperty.call(t, "componentWillUnmount")) {
        var e = t.componentWillUnmount;
        return t.componentWillUnmount = function () {
          Object(o.a)(t), e.apply(void 0, arguments);
        }, !0;
      }

      return !1;
    },
        s = function s(t) {
      var e = Object.getPrototypeOf(t);
      Object.prototype.hasOwnProperty.call(e, "componentWillUnmount") && (t.componentWillUnmount = function () {
        Object(o.a)(t), e.componentWillUnmount.bind(t).apply(void 0, arguments);
      });
    },
        y = function y(t) {
      return function (e) {
        function n() {
          var t, e;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, n);

          for (var r = arguments.length, i = new Array(r), c = 0; c < r; c++) {
            i[c] = arguments[c];
          }

          return function (t, e, n) {
            e in t ? Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[e] = n;
          }(l(l(e = function (t, e) {
            return !e || "object" !== u(e) && "function" != typeof e ? l(t) : e;
          }(this, (t = a(n)).call.apply(t, [this].concat(i))))), "_globalCallback", function () {
            Object(o.c)(l(l(e)));
          }), !f(l(l(e))) && s(l(l(e))), e;
        }

        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && c(t, e);
        }(n, t), function (t, e, n) {
          e && i(t.prototype, e), n && i(t, n);
        }(n, [{
          key: "componentWillUnmount",
          value: function value() {
            Object(o.a)(this);
          }
        }, {
          key: "setGlobal",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            return Object(o.d)(this, t, e, !0);
          }
        }, {
          key: "global",
          get: function get() {
            return Object(o.b)(this);
          }
        }]), n;
      }();
    },
        p = y(r.Component),
        b = y(r.PureComponent);
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "default", function () {
      return o;
    });
    var r = n(5);

    function o(t, e, n) {
      t.addReducer(e, Object(r.a)(n));
    }
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "default", function () {
      return v;
    });
    var r = n(1),
        o = n(7),
        u = n(3),
        i = n(0);

    function a(t) {
      return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function c(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function l(t) {
      return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function f(t, e) {
      return (f = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function s(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function y(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var p = !1,
        b = !1,
        d = !1;

    function v() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function (t) {
        return t;
      },
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function () {
        return null;
      };
      return function (v) {
        var h, m;
        return m = h = function (u) {
          function h() {
            var e, n;
            !function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, h);

            for (var r = arguments.length, o = new Array(r), u = 0; u < r; u++) {
              o[u] = arguments[u];
            }

            return y(s(s(n = function (t, e) {
              return !e || "object" !== a(e) && "function" != typeof e ? s(t) : e;
            }(this, (e = l(h)).call.apply(e, [this].concat(o))))), "setGlobal", function (e) {
              var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
              return Object(i.d)(s(s(n)), e, r, !p && !b && !d, t || n.context || defaultGlobalState);
            }), n;
          }

          return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
              constructor: {
                value: t,
                writable: !0,
                configurable: !0
              }
            }), e && f(t, e);
          }(h, o["ReactNPureComponent"]), function (t, e, n) {
            e && c(t.prototype, e), n && c(t, n);
          }(h, [{
            key: "render",
            value: function value() {
              return Object(r.createElement)(v, function (t) {
                for (var e = 1; e < arguments.length; e++) {
                  var n = null != arguments[e] ? arguments[e] : {},
                      r = Object.keys(n);
                  "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
                    return Object.getOwnPropertyDescriptor(n, t).enumerable;
                  }))), r.forEach(function (e) {
                    y(t, e, n[e]);
                  });
                }

                return t;
              }({}, this.props, e(this.global, this.props), n(this.setGlobal, this.props)));
            }
          }, {
            key: "global",
            get: function get() {
              return Object(i.b)(this, t || this.context || defaultGlobalState);
            }
          }]), h;
        }(), y(h, "contextType", u.a), y(h, "displayName", (v.displayName || v.name) + "-ReactN"), m;
      };
    }
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(1),
        o = n.n(r),
        u = n(11),
        i = n.n(u),
        a = n(3),
        c = n(5),
        l = n(2),
        f = n(4);

    function s(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
      if (!o.a.useContext) throw new Error("The installed version of React does not support Hooks, which are required for useGlobal.");
      var r = t || o.a.useContext(a.a) || l.default,
          u = i()();

      if (o.a.useEffect(function () {
        return function () {
          r.removePropertyListener(u);
        };
      }), !e) {
        var s = function s(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          Object(f.default)(r, t, e);
        };

        return n ? s : [r.spyStateWithReducers(u), s];
      }

      if ("function" == typeof e) {
        var y = Object(c.a)(e);
        return function (t) {
          for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) {
            n[r - 1] = arguments[r];
          }

          for (var o = n.length, u = 0; u < o; u++) {
            t[u] = n[u];
          }

          t.slice = n.slice.bind(n), t[Symbol.iterator] = function () {
            var t = 0;
            return {
              next: function next() {
                return t < o ? {
                  done: !1,
                  value: n[t++]
                } : (t = 0, {
                  done: !0
                });
              }
            };
          };
        }(y, r.spyStateWithReducers(u), y), y;
      }

      if (r.hasReducer(e)) return r.getReducer(e);

      var p = function p(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        return r.setAnyCallback(function (t, e, n) {
          return e in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[e] = n, t;
        }({}, e, t), n);
      };

      return n ? p : [r.spyState(u)[e], p];
    }

    n.d(e, "default", function () {
      return s;
    });
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__read || function (t, e) {
      var n = "function" == typeof Symbol && t[Symbol.iterator];
      if (!n) return t;
      var r,
          o,
          u = n.call(t),
          i = [];

      try {
        for (; (void 0 === e || e-- > 0) && !(r = u.next()).done;) {
          i.push(r.value);
        }
      } catch (t) {
        o = {
          error: t
        };
      } finally {
        try {
          r && !r.done && (n = u.return) && n.call(u);
        } finally {
          if (o) throw o.error;
        }
      }

      return i;
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = n(1);

    e.default = function () {
      var t = r(o.useState(0), 2)[1];
      return function () {
        t(function (t) {
          return (t + 1) % 9007199254740990;
        });
      };
    };
  }, function (t, e, n) {
    var r = n(1),
        o = n(7),
        u = o.ReactNComponent,
        i = o.ReactNPureComponent,
        a = n(13).default,
        c = n(2).default,
        l = n(8).default,
        f = n(14).default,
        s = n(4).default,
        y = n(10).default,
        p = n(9).default;
    Object.assign(a, r, {
      addCallback: function addCallback(t) {
        return c.addCallback(t);
      },
      addReducer: function addReducer(t, e) {
        return l(c, t, e);
      },
      Component: u,
      createProvider: f,
      default: a,
      getGlobal: function getGlobal() {
        return c.stateWithReducers;
      },
      PureComponent: i,
      removeCallback: function removeCallback(t) {
        return c.removeCallback(t);
      },
      resetGlobal: function resetGlobal() {
        return c.reset();
      },
      setGlobal: function setGlobal(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        return s(c, t, e);
      },
      useGlobal: function useGlobal(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return y(null, t, e);
      },
      withGlobal: function withGlobal() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : function (t) {
          return t;
        },
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {
          return null;
        };
        return p(null, t, e);
      }
    }), t.exports = a;
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "default", function () {
      return b;
    });
    var r = n(0);

    function o(t) {
      return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function u(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function i(t, e, n) {
      return (i = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = a(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function a(t) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function c(t, e) {
      return (c = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function l(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function f(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var s = !1,
        y = !1,
        p = !1;

    function b(t) {
      var e = function (e) {
        function n() {
          var t, e;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, n);

          for (var u = arguments.length, i = new Array(u), c = 0; c < u; c++) {
            i[c] = arguments[c];
          }

          return f(l(l(e = function (t, e) {
            return !e || "object" !== o(e) && "function" != typeof e ? l(t) : e;
          }(this, (t = a(n)).call.apply(t, [this].concat(i))))), "_globalCallback", function () {
            Object(r.c)(l(l(e)));
          }), e;
        }

        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && c(t, e);
        }(n, t), function (t, e, n) {
          e && u(t.prototype, e), n && u(t, n);
        }(n, [{
          key: "componentWillUnmount",
          value: function value() {
            if (Object(r.a)(this), i(a(n.prototype), "componentWillUnmount", this)) {
              for (var t, e = arguments.length, o = new Array(e), u = 0; u < e; u++) {
                o[u] = arguments[u];
              }

              (t = i(a(n.prototype), "componentWillUnmount", this)).call.apply(t, [this].concat(o));
            }
          }
        }, {
          key: "setGlobal",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            return Object(r.d)(this, t, e, !s && !y && !p);
          }
        }, {
          key: "global",
          get: function get() {
            return Object(r.b)(this);
          }
        }]), n;
      }();

      return f(e, "displayName", (t.displayName || t.name) + "-ReactN"), Object.prototype.hasOwnProperty.call(t, "getDerivedGlobalFromProps") && (e.getDerivedStateFromProps = Object(r.e)(t)), e;
    }
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "default", function () {
      return d;
    });
    var r = n(1),
        o = n(3),
        u = n(6),
        i = n(8),
        a = n(4),
        c = n(10),
        l = n(9);

    function f(t) {
      return (f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function s(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function y(t, e) {
      return !e || "object" !== f(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function p(t) {
      return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function b(t, e) {
      return (b = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function d() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
          e = new u.a(),
          n = e.setAny(t),
          f = function (t) {
        function n() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, n), y(this, p(n).apply(this, arguments));
        }

        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && b(t, e);
        }(n, r["Component"]), function (t, e, n) {
          e && s(t.prototype, e), n && s(t, n);
        }(n, [{
          key: "render",
          value: function value() {
            return React.createElement(o.a.Provider, {
              value: e
            }, this.props.children);
          }
        }], [{
          key: "addCallback",
          value: function value(t) {
            return e.addCallback(t);
          }
        }, {
          key: "addReducer",
          value: function value(t, n) {
            return Object(i.default)(e, t, n);
          }
        }, {
          key: "getGlobal",
          value: function value() {
            return e.stateWithReducers;
          }
        }, {
          key: "removeCallback",
          value: function value(t) {
            return e.removeCallback(t);
          }
        }, {
          key: "resetGlobal",
          value: function value() {
            return e.reset();
          }
        }, {
          key: "setGlobal",
          value: function value(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            return Object(a.default)(e, t, n);
          }
        }, {
          key: "useGlobal",
          value: function value(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return Object(c.default)(t, n, e);
          }
        }, {
          key: "withGlobal",
          value: function value() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : function (t) {
              return t;
            },
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {
              return null;
            };
            return Object(l.default)(e, t, n);
          }
        }, {
          key: "global",
          get: function get() {
            return e.stateWithReducers;
          }
        }]), n;
      }();

      return n instanceof Promise ? n.then(function () {
        return f;
      }) : f;
    }
  }]);
});